<template>
  <div class="main">
    <div class="query-item">
      <div class="search-l">
        <div v-if="!store.roles.includes('carEnterprise')" style="margin-right: 30px;">
          企业名称
          <a-input class="inp ml24" placeholder="请输入" v-model:value="query.deptName"></a-input>
        </div>
        <div>
          姓名
          <a-input class="inp ml24" placeholder="请输入" v-model:value="query.name"></a-input>
        </div>
        <div v-if="store.roles.includes('carEnterprise')" class="ml30">
          类型
          <a-select class="inp ml24" v-model:value="query.personType">
            <a-select-option value="">全部</a-select-option>
            <a-select-option value="driver">驾驶员</a-select-option>
            <a-select-option value="security">安全员</a-select-option>
          </a-select>
        </div>

        <a-button class="ml30" @click="search" type="primary" ghost>查询</a-button>
        <a-button class="ml24" @click="reset" type="primary" ghost>重置</a-button>
      </div>
      <div class="search-r">
        <a-button class="ml30" @click="add" type="primary">+ 新建</a-button>
        <!-- v-if="store.roles.includes('carEnterprise')" -->
        <a-button v-if="store.roles.includes('carEnterprise')" class="ml24" @click="delMore" type="primary"><i
            class="iconfont icon-shanchuanniu mr5"></i>批量删除</a-button>
      </div>
    </div>

    <a-modal v-model:open="visible" title="Basic Modal" @ok="handleOk">
      <iframe :src="imgVisbleURL" frameborder="0" width="100%" height="600"></iframe>
    </a-modal>


    <!-- 管理端 -->
    <a-table :columns="store.roles.includes('carEnterprise') ? columns2 : columns" :row-key="(record) => record.id"
      :data-source="dataSource" size="middle" class="mt23" :pagination="pagination" :scroll="{ y: 'auto', }"
      v-autoHeight="{ extraHeight: 88, trHeight: 47 }" :row-selection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
        }">
      <template #bodyCell="{ column, record, index }">
        <template v-if="column.key === 'ranking'">
          {{ (pagination.current - 1) * pagination.pageSize + index + 1 }}
        </template>
        <template v-if="column.key === 'gender'">
          {{ record.gender === 0 ? '女' : '男' }}
        </template>
        <template v-if="column.key === 'idNumber'">
          {{ record.certificateType === 'idCard' ? '身份证' : '' }}
          <span v-if="record.certificateNum">/</span>
          {{ record.certificateNum }}
        </template>
        <template v-if="column.key === 'personType'">
          {{ record.personType ? record.personType.split(',')[0] === 'driver' ? '驾驶员' : record.personType.split(',')[0]
          === 'security' ? '安全员' : '' : '' }}
          <span v-if="record.personType && record.personType.split(',')[1]">/</span>
          {{ record.personType ? record.personType.split(',')[1] ? record.personType.split(',')[1] ===
          'driver' ? '驾驶员' : record.personType.split(',')[1]
            === 'security' ? '安全员' : '' : '' : '' }}
        </template>
        <template v-if="column.key === 'createTime'">
          {{ moment(record.createTime).format("YYYY-MM-DD HH:mm:ss") }}
        </template>
        <template v-if="column.key === 'status'">
          <a-switch v-model:checked="record.status" @change="switchChange(record)" checked-children="启用"
            un-checked-children="禁用" />
        </template>

        <template v-if="column.key === 'action'">
          <span>
            <a class="ml10" @click="detail(record)">详情</a>
            <a class="ml10" @click="edit(record)">编辑</a>
            <!-- v-if="store.roles.includes('carEnterprise')" -->
            <a-popconfirm v-if="store.roles.includes('carEnterprise')" title="确定删除？" ok-text="是" cancel-text="否"
              @confirm="del(record)">
              <a class="ml10">删除</a>
            </a-popconfirm>

          </span>
        </template>
      </template>
    </a-table>

    <addBox ref="addBoxRef" :drawerTitle="drawerTitle" :data="selectRecord" @drawerEvent="save"></addBox>
  </div>
</template>
<script setup>
import { ref, onMounted, reactive, watch } from "vue";
import { useRouter } from "vue-router";
import { message, Modal } from 'ant-design-vue'
import {
  getPagesByCondition,
  insert,
  updateById,
  deleteById,
  deleteByBatchId
} from "@/api/securityUser/index.js";
import moment from "moment";
import addBox from './components/add.vue'
import useUserStore from '@/store/modules/user'
import { Base64 } from 'js-base64'


const router = useRouter();
const store = useUserStore();


const columns = [
  {
    title: "序号",
    // dataIndex: "ranking",
    key: "ranking",
    width: 90
  },
  {
    title: "企业名称",
    dataIndex: "deptName",
    key: "deptName",
  },
  {
    title: "姓名",
    dataIndex: "name",
    key: "name",
    width: 100,
  },
  {
    title: "性别",
    key: "gender",
    // dataIndex: "gender",
    width: 80,
  },
  {
    title: "出生年月",
    key: "birthDate",
    dataIndex: "birthDate",
  },
  {
    title: "证件类型及证件号",
    key: "idNumber",
    // dataIndex: "idNumber",
    width: 240,
  },
  {
    title: "电话号码",
    key: "phoneNum",
    dataIndex: "phoneNum",
  },
  {
    title: "类型",
    key: "personType",
    // dataIndex: "personType",
  },
  {
    title: "状态",
    key: "status",
    // dataIndex: "status",
  },
  {
    title: "更新时间",
    key: "updateTime",
    dataIndex: "updateTime",
  },
  {
    title: "操作",
    key: "action",
  },
];

//columns2 车企端
const columns2 = [
  {
    title: "序号",
    // dataIndex: "ranking",
    key: "ranking",
    width: 90
  },
  {
    title: "姓名",
    dataIndex: "name",
    key: "name",
    width: 100,
  },
  {
    title: "性别",
    key: "gender",
    // dataIndex: "gender",
    width: 80,
  },
  {
    title: "出生年月",
    key: "birthDate",
    dataIndex: "birthDate",
  },
  {
    title: "证件类型及证件号",
    key: "idNumber",
    // dataIndex: "idNumber",
    width: 240,
  },
  {
    title: "电话号码",
    key: "phoneNum",
    dataIndex: "phoneNum",
  },
  {
    title: "类型",
    key: "personType",
    // dataIndex: "personType",
  },
  {
    title: "状态",
    key: "status",
    // dataIndex: "status",
  },
  {
    title: "更新时间",
    key: "updateTime",
    dataIndex: "updateTime",
  },
  {
    title: "操作",
    key: "action",
  },
];

const visible = ref(false)
const imgVisbleURL = ref(null)


let drawerTitle = ref('编辑');
let selectRecord = ref();

let dataSource = ref([]);
let query = reactive({
  deptName: '',
  name: "",
  personType: ''
});



const pagination = reactive({
  total: 0,
  size: "middle",
  defaultPageSize: 10,
  current: 1,
  pageSize: 10, //每页中显示10条数据
  showSizeChanger: true,
  showQuickJumper: false,
  pageSizeOptions: ["10", "20", "30"], //每页中显示的数据
  showTotal: (total) => `共有 ${total} 条数据`, //分页中显示总的数据
  onShowSizeChange: (current, pageSize) => (pagination.pageSize = pageSize), // 改变每页数量时更新显示
  onChange: pageChange, //点击页码事件
  showSizeChange: pageSizeChange,
});

function pageChange(page, pageSize) {
  pagination.current = page;

  // 获取表格数据
  getData();
}

function pageSizeChange(current, size) {
  console.log(size);
  pagination.pageSize = size;

  // 获取表格数据
  getData();
}

const search = () => {
  pagination.current = 1
  getData();

  // var url = "http://xgame-icv.zbmec.com:9000/qf-test-management-provincial/c_material_template_info/qualification_apply_file/道路测试或示范应用车辆基本情况说明.docx" //要预览文件的访问地址

  // 当前页面 在线预览
  // imgVisbleURL.value = 'http://192.168.3.35:8012/onlinePreview?url=' + encodeURIComponent(Base64.encode(url))
  // visible.value = true

  // 在线预览 跳转新页面
  // window.open('http://192.168.3.35:8012/onlinePreview?url=' + encodeURIComponent(Base64.encode(url)));

};

const handleOk = e => {
  console.log(e);
  visible.value = false;
};

const reset = () => {
  query.deptName = "";
  query.name = "";
  query.personType = ""
  pagination.current = 1
  getData()
};



const switchChange = (record) => {
  console.log(record);
  let status
  switch (record.status) {
    case true:
      status = 1;
      break;
    case false:
      status = 0
      break;
    default:
      status = null
  }
  updateById({ id: record.id, status: status }).then(res => {
    console.log(res);
    if (res.code === 200) {
      message.success('修改成功')
      getData()
    }
  })

}



const getData = () => {
  const data = {
    pageIndex: pagination.current,
    pageSize: pagination.pageSize,
    conditionMap: { ...query, deptId: store.deptId },
  };
  getPagesByCondition(data).then((res) => {
    console.log(res);
    if (res.code === 200) {
      res.data.records.map((item, index) => {
        item.status = item.status === 1 ? true : false;
      });
      dataSource.value = res.data.records || [];
      pagination.total = res.data.total;
    }
  });
};


// 多选数据
const selectedRowKeys = ref([]);

const onSelectChange = (value) => {
  console.log("selectedRowKeys changed: ", value);
  selectedRowKeys.value = value;
};

// 批量删除
const delMore = () => {
  if (selectedRowKeys.value.length < 1) {
    message.warning("请选中要删除的数据！");
    return false;
  } else {
    Modal.confirm({
      title: '确认批量删除，该操作不可逆?',
      onOk() {
        console.log(selectedRowKeys.value);
        // 删除接口
        deleteByBatchId(selectedRowKeys.value).then((res) => {
          if (res.code === 200) {
            message.success("批量删除成功");
            getData();
          }
        });
      },
      onCancel() { },
    });

  }
};

onMounted(async () => {
  getData();
});

const detail = (record) => {
  console.log(record);
  router.push({
    path: "/personnelManage/personnelDetail",
    query: {
      num: 1,
      modelId: record.id
    }
  });

};


const edit = (record) => {
  console.log(record);
  drawerTitle.value = "编辑";
  selectRecord.value = record;
  addBoxRef.value.showDrawer(record)
};

//编辑后保存 接口
function save(info) {
  let data = JSON.parse(JSON.stringify(info));
  data.personType = data.personType.join(',')


  if (drawerTitle.value === '新增') {
    console.log(data);
    insert(data).then(res => {
      if (res.code === 200) {
        message.success('新增成功')
        getData()
      }
    })
  } else {
    console.log(data);
    updateById(data).then(res => {
      if (res.code === 200) {
        message.success('编辑成功')
        getData()
      }
    })
  }


}

const del = (record) => {
  console.log(record);
  deleteById(record.id).then(res => {
    if (res.code === 200) {
      message.success('删除成功')
      getData()
    }
  })
};

const addBoxRef = ref();
const add = function () {
  selectRecord.value = null;
  drawerTitle.value = "新增";
  addBoxRef.value.showDrawer()
}


</script>

<style lang="less" scoped>
.inp {
  width: 13.5vw;
}

.query-item {
  display: flex;
  justify-content: space-between;

  .search-l {
    display: flex;
  }

  .search-r {
    display: flex;
  }
}

/deep/.ant-input::placeholder {
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #68767E;
}

/deep/.ant-select-selector {
  background-color: #F2F4F7 !important;
  color: #68767E !important;
}

.main {
  padding: 20px;
  height: calc(100vh - 70px - 57px);
  background-color: #ffffff;
}

/deep/ .ant-table-wrapper .ant-table-thead>tr>th,
.ant-table-wrapper .ant-table-thead>tr>td {
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(10, 33, 46, 1);
  background-color: rgba(239, 240, 245, 1);
}

/deep/.ant-table-wrapper .ant-table:not(.ant-table-bordered) .ant-table-tbody>tr {
  color: rgba(104, 118, 126, 1);
}

/deep/ .ant-table-wrapper .ant-table-thead>tr>th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before,
.ant-table-wrapper .ant-table-thead>tr>td:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {
  width: 0px;
}

a {
  color: #1E8EF2;
}
</style>
